module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('Site_Page_Promo', {

		configure: function(options) {
			this.registerOptions('', {
				handleWom: {
					scrolling: {
						widget: '@root #windowScrollHandler',
						event: 'topPointReached',
						callback: 'changeHeaderColor'
					},
					addedToDom: {
						widget: '.Widget',
						event: 'addedToDom',
						callback: 'prepareElements'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		changeHeaderColor: function(param) {
			$('#promo-header').toggleClass('header-bg', param.direction === 1 ? true : false);
		},

		prepareElements: function() {
			fox.wom.selectFirst("@root #windowScrollHandler").enable();
		},

	}, 'Site_Page');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/promo.js
// module id = 210
// module chunks = 5